<template>
  <div :class="treeClasses" :style="{width, height}">
    <template v-if="isEmpty">
      <div class="px-12" style="padding: 10px 0">
        {{ localeEmptyText }}
      </div>
    </template>
    <template v-else>
      <ul class="m-0 p-0"
          @click.stop="$_onTreeClick"
      >
        <t-tree-node
          v-for="rootNodeModel in treeModel.roots"
          :key="rootNodeModel.id"
          :data-key="rootNodeModel.id"
          :node-key="nodeKey"
          :multiple="multiple"
          :node-render="nodeRender"
          :horizontal-scroll="horizontalScroll"
          :auxiliary-line="auxiliaryLine"
          :node-model="rootNodeModel"
        ></t-tree-node>
      </ul>
    </template>
  </div>
</template>
<script>
import Locale from '../../mixins/locale'
import { PREFIX_CLASS } from '../../utils/constants'
import TTreeNode from './tree-node.vue'
import { Tree } from './tree-model'
import bus from '../../utils/bus'
import {
  BUS_TREE__SELECT
} from './constants'

const PREFIX_TREE_CLASS = `${PREFIX_CLASS}tree`
export default {
  name: 'TTree',
  components: {
    TTreeNode
  },
  provide() {
    return {
      owner: this
    }
  },
  mixins: [ Locale ],
  props: {
    comparer: {
      type: Function,
      default: null
    },
    width: {
      type: [Number, String],
      default: 'auto'
    },
    height: {
      type: [Number, String],
      default: 'auto'
    },
    nodeData: {
      type: Array,
      default: null
    },
    nodeRender: {
      type: Function,
      default: null
    },
    // 是否遍历祖先节点
    withAncestors: {
      type: Boolean,
      default: false
    },
    // 是否遍历子孙节点
    withDescendants: {
      type: Boolean,
      default: false
    },
    handleFoldedIcon: {
      type: String,
      default: '' // 将使用模型默认值
    },
    handleExpandedIcon: {
      type: String,
      default: '' // 将使用模型默认值
    },
    loadingAni: {
      type: String,
      default: '' // 将使用模型默认值
    },
    foldedIcon: {
      type: String,
      default: '' // 将使用模型默认值
    },
    expandedIcon: {
      type: String,
      default: '' // 将使用模型默认值
    },
    leafIcon: {
      type: String,
      default: '' // 将使用模型默认值
    },
    lazyIcon: {
      type: String,
      default: '' // 将使用模型默认值
    },
    // 节点数据中能唯一标识节点的属性名
    nodeKey: {
      type: String,
      default: '' // 将使用模型默认值
    },
    multiple: {
      type: Boolean,
      default: false
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    horizontalScroll: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: ''
    },
    beforeSelect: {
      type: Function,
      default: null
    },
    beforeExpand: {
      type: Function,
      default: null
    },
    beforeFold: {
      type: Function,
      default: null
    },
    lazyLoader: {
      type: Function,
      default: null
    },
    auxiliaryLine: {
      type: Boolean,
      default: false
    },
    rowHighlight: {
      type: Boolean,
      default: false
    },
    // 选中节点Id
    value: {
      type: Array,
      default: () => []
    },
    filterValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      treeModel: null,
      prevNodeId: '',
      currentAuxiliaryLine: false,
      originNodeDate: '',
      fromInnerChange: false,
      type: ''
    }
  },
  computed: {
    localeEmptyText() {
      if (!this.emptyText) {
        return this.t('t.tree.emptyText')
      } else {
        return this.emptyText
      }
    },
    treeClasses() {
      return [
        PREFIX_TREE_CLASS,
        {
          [`${PREFIX_TREE_CLASS}--aux-line`]: this.currentAuxiliaryLine,
          [`${PREFIX_TREE_CLASS}--multiple`]: this.multiple
        }
      ]
    },
    isEmpty() {
      return this.treeModel.isEmpty || this.treeModel.switchEmpty
    },
    currentHandleFoldedIcon() {
      return this.treeModel.handleFoldedIcon
    },
    currentHandleExpandedIcon() {
      return this.treeModel.handleExpandedIcon
    },
    currentLoadingAni() {
      return this.treeModel.loadingAni
    },
    currentFoldedIcon() {
      return this.treeModel.foldedIcon
    },
    currentExpandedIcon() {
      return this.treeModel.expandedIcon
    },
    currentLeafIcon() {
      return this.treeModel.leafIcon
    },
    currentLazyIcon() {
      return this.treeModel.lazyIcon
    }
  },
  watch: {
    filterValue(val) {
      let filterList = []
      let IdList = []
      let isIncludes
      if (val !== '') {
        this.each(function(id, tree) {
          isIncludes = tree.nodes[id].label.indexOf(val)
          IdList.push(id)
          if (isIncludes > -1) {
            filterList.push(tree.nodes[id].id)
          }
        })
      } else {
        filterList = null
      }
      this.treeModel.filterNodes(filterList)
    },
    value(ids) {
      if (this.fromInnerChange === false) { // 从组件外部改变了值
        if (this.multiple === false) {
          this.$_selectNode(ids[0])
          this.treeNodeHighlight(ids[0])
        } else {
          let currentSelectedNodeIds = this.treeModel.selectedNodeIds
          for (let nodeId = currentSelectedNodeIds.length - 1; nodeId >= 0; nodeId--) {
            this.treeModel.setSelected(currentSelectedNodeIds[nodeId], false)
          }
          for (let nodeId = ids.length - 1; nodeId >= 0; nodeId--) {
            this.treeModel.setSelected(ids[nodeId], true)
          }
        }
      } else {
        this.fromInnerChange = false
      }
    },
    nodeData(val) {
      this.reload(val)
    }
  },
  created() {
    this.currentAuxiliaryLine = this.auxiliaryLine
    this.treeModel = new Tree({
      withAncestors: this.withAncestors,
      withDescendants: this.withDescendants,
      handleFoldedIcon: this.handleFoldedIcon,
      handleExpandedIcon: this.handleExpandedIcon,
      foldedIcon: this.foldedIcon,
      expanded: true,
      expandedIcon: this.expandedIcon,
      leafIcon: this.leafIcon,
      lazyIcon: this.lazyIcon,
      loadingAni: this.loadingAni,
      multiple: this.multiple,
      lazyLoader: this.lazyLoader,
      comparer: this.comparer
    })
    this.reload(this.nodeData)
    bus.$on(BUS_TREE__SELECT, this.$_onBusTreeSelect)
  },
  destroy() {
    this.treeModel.destroy()
  },
  methods: {
    expandAllTree() {
      for (let i = 0; i < this.nodeData.length; i++) {
        let arr = []
        let isSelect = false
        arr.push(this.nodeData[i].id)
        if (this.nodeData[i].selected) isSelect = true
        this.treeModel.setSelected(arr[0], isSelect)
      }
    },
    $_selectNode(nodeId) {
      if (nodeId && this.prevNodeId !== nodeId) {
        if (this.beforeSelect) {
          let result = this.beforeSelect(nodeId, this.prevNodeId)
          if (result === false) {
            return // 如果钩子函数明确返回false，那么取消节点切换动作
          }
        }
        if (this.prevNodeId !== '') {
          this.treeModel.setSelected(this.prevNodeId, false)
        }
        this.prevNodeId = nodeId
        this.treeModel.setSelected(nodeId, true)
      }
    },
    $_rockNode(nodeId) {
      let nodeModel = this.treeModel.getNodeById(nodeId)
      if (nodeModel && nodeModel.expanded) {
        if (this.beforeFold) {
          let result = this.beforeFold(nodeModel.state)
          if (result === false) {
            return // 取消收起动作
          }
        }
        nodeModel.fold()
        this.$emit('fold', nodeModel.state)
      } else {
        if (this.beforeExpand) {
          let result = this.beforeExpand(nodeModel.state)
          if (result === false) {
            return // 取消展开动作
          }
        }
        this.treeModel.expand(nodeId).then((nodeId) => {
          this.$emit('expand', nodeModel.state)
        })
      }
    },
    treeNodeHighlight(nodeId) {
      if (!this.rowHighlight) return
      let _nodes = this.treeModel.nodes
      for (let key in _nodes) {
        _nodes[key].lineLight = false
      }
      nodeId in _nodes && (_nodes[nodeId].lineLight = true)
    },
    $_onTreeClick(event) {
      let target = event.target
      let role = target.getAttribute('data-role')
      let nodeId = target.getAttribute('data-node-id')
      switch (role) {
        case 'tree-node-label':
          this.$_rockNode(nodeId)
          if (this.treeModel._nodes[nodeId].disabled) break
          if (this.multiple === false) {
            this.fromInnerChange = true
            this.$_selectNode(nodeId)
            this.$emit('input', [nodeId])
            this.$emit('select', [nodeId])
          }
          this.treeNodeHighlight(nodeId)
          break
        case 'tree-node-handle':
          this.$_rockNode(nodeId)
          break
        case 'tree-node-checkbox':
          if (!this.treeModel.multiple || this.treeModel._nodes[nodeId].disabled) break
          this.fromInnerChange = true
          let wantSelected = !this.treeModel.getNodeById(nodeId).selected
          this.treeModel.setSelected(nodeId, wantSelected)
          let selectedNodeIds = this.treeModel.selectedNodeIds
          this.$emit('input', selectedNodeIds)
          this.$emit('select', selectedNodeIds)
          break
        default:
          break
      }
    },
    $_onBusTreeSelect(owner, nodeId, wantSelected) {
      if (owner === this) {
        if (this.treeModel.multiple) {
          this.treeModel.setSelected(nodeId, wantSelected)
        }
      }
    },
    /**
     * DFS遍历树中所有节点
     * @param {Function} [before=null] 迭代前回掉函数
     */
    each(before) {
      this.treeModel.each(before)
    },
    /**
     * 从指定节点开始进行DFS遍历
     * @param {String} nodeId 节点Id
     * @param {Function} [before=null] 迭代前回掉函数
     * @param {Boolean} [withAncestors=false] 是否遍历祖先节点。如果在遍历时不需要遍历该节点的祖先节点，那么将其设置为`false`，否则设置为`true`。
     * @param {Boolean} [withDescendants=true] 是否遍历子孙节点。如果在遍历时不需要遍历该节点的子孙节点，那么将其设置为`false`，否则设置为`true`。
     */
    eachById(nodeId, before, withAncestors = null, withDescendants = null) {
      let finalWithAncestors = withAncestors || this.withAncestors
      let finalWithDescendants = withDescendants || this.withDescendants
      this.treeModel.eachById(nodeId, before, null, finalWithAncestors, finalWithDescendants)
    },
    /**
     * 加载树
     * @param {Array} data 树数据
     */
    reload(data) {
      this.originNodeDate = data
      this.treeModel.reload(data, this.nodeKey)
      if (this.defaultExpandAll === true) {
        this.expandAllTree()
      }
      if (this.multiple) {
        for (let i = this.value.length - 1; i >= 0; i--) {
          this.treeModel.setSelected(this.value[i], true)
        }
      } else {
        if (this.value.length > 0) {
          this.treeModel.setSelected(this.value[0], true)
          this.prevNodeId = this.value[0]
          this.treeNodeHighlight(this.value[0])
        }
      }
    },
    /**
     * 删除指定节点
     * @param {String} nodeId 节点Id
     */
    deleteNode(nodeId) {
      this.treeModel.deleteNode(nodeId)
    },
    /**
     * 添加节点
     * @param {Object} nodeState 节点对象
     * @param {String} [nodeState.id=''] 节点Id，如果没有传入默认生成一个新Id。
     * @param {String} nodeState.pid 父节点Id。
     * @param {String} [nodeState.label=''] 节点标签文本。
     * @param {String} [nodeState.title=''] 节点提示文本。
     * @param {Boolean} nodeState.selected 节点是否被选中，选中为`true`，否则为`false`。
     * @param {String} [nodeState.foldedIcon=Tree.FOLDED_ICON] 折叠状态时的图标样式类名。
     * @param {String} [nodeState.expandedIcon=Tree.EXPANDED_ICON] 展开状态时的图标样式类名。
     * @param {String} [nodeState.leafIcon=Tree.LEAF_ICON] 无子节点状态（叶子节点）时的图标样式类名。
     * @param {String} [nodeState.lazyIcon=Tree.LAZY_ICON] 懒加载节点状态时的图标样式类名。
     * @param {String} [nodeState.loadingAni=Tree.LOADING_ANT] 节点加载状态时的图标样式类名。
     * @param {*} [nodeState.data] 绑定到节点的业务数据。
     * @param {Array} [nodeState.lazy=false] 是否是懒加载节点，如果为`true`则表示此节点可能存在子节点但是还没有加载，否则为`false`。
     * @param {Boolean} [nodeState.visibled=false] 是否可见，如果为`true`则表示此节点可见，否则为`false`。
     * @param {Boolean} [nodeState.disabled=true] 是否可用，如果为`true`则表示此节点可用，否则为`false`。
     */
    addNode(nodeState) {
      this.treeModel.addNode(nodeState)
    },
    /**
     * 清空树
     */
    clear() {
      this.treeModel.clear()
    },
    /**
     * 根据节点Id获得节点状态
     * @param {String} nodeId 节点Id
     * @returns {Object} 返回节点Id对应的节点的当前状态对象
     */
    getNodeStateById(nodeId) {
      return this.treeModel.getNodeStateById(nodeId)
    },
    /**
     * 获得所有选中节点实例
     * @returns {Array} 返回所有选中节点的实例
     */
    getSelectedNodes() {
      let nodes = []
      let selectedNodes = this.treeModel.selectedNodes
      for (let id in selectedNodes) {
        nodes.push(selectedNodes[id])
      }
      return nodes
    },
    /**
     * 获得所有选中节点的状态
     * @returns {Array} 返回所有选中节点的状态对象数组
     */
    getSelectedNodeStates() {
      return this.treeModel.selectedNodeStates
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/tree/tree.vue